import React from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import CircularProgress from '@material-ui/core/CircularProgress'
import GridProfile from './GridProfile'
import { Link } from 'react-router-dom'
import Place from '@material-ui/icons/Place'
import Typography from '@material-ui/core/Typography'
import Footer from './Footer'

const styles = theme => ({
    root: {
      width: '100%',
      backgroundColor: theme.palette.background.paper,
    },
    flex: {
        flex: 1,
    },
    link: {
        textDecoration: 'none'
    },
    button: {
        // margin: theme.spacing.unit,
        marginLeft: 'auto',
        border: '1px solid #ccc',
        color: 'rgba(0, 0, 0, 0.54)',
        padding: '3px 9px',
        borderRadius: '5px'
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    iconSmall: {
        fontSize: 20,
    },
    searchPlaceList: {
        paddingTop: 0
    }
})
 
const DisplayLists = ({ classes, isFetchingPosts, posts, i18n }) => (
    <div className={classes.root}>
        {/* <List className={classes.searchPlaceList}>
            <ListItem divider={true}>
                <Typography variant="title" color="textSecondary" noWrap>
                    搜尋全台北市
                </Typography>
                <Button color="secondary" className={classes.button} size="small">
                    <Place className={classNames(classes.leftIcon)} />
                    搜尋設定
                </Button>
            </ListItem>
        </List> */}
        {isFetchingPosts && <CircularProgress style={{marginLeft: 'auto', marginRight: 'auto', display: 'block'}} />}
        {!isFetchingPosts && <List>
            {posts.map((post, index) => 
                (post.show && <Link to={`/profile/${post.displayName.replace(/\s+/g, '-').toLowerCase()}-${post.UID}`} key={index} className={classes.link} ><GridProfile post={post} /></Link>)
            )}
        </List>}
        <List style={{ backgroundColor: '#009688' }}>
            <ListItem>
                <Footer/>
            </ListItem>
        </List>
    </div>
)

DisplayLists.propTypes = {
    classes: PropTypes.object.isRequired,
}
  
export default withStyles(styles)(DisplayLists)


// WEBPACK FOOTER //
// ./src/components/DisplayLists.js